import { call, put, SagaReturnType, takeEvery } from 'redux-saga/effects';
import { DashboardConstants } from 'src/redux/actions/constant';
import dashboardServices from 'src/services/apiServices/dashboard-services/dashboard-services';
const {
    APPLY_THERAPIST_BULK_SIGNATURE_REQUEST,
    APPLY_THERAPIST_BULK_SIGNATURE_SUCCESS,
    APPLY_THERAPIST_BULK_SIGNATURE_FAILURE,
    APPLY_THERAPIST_BULK_SIGNATURE_LOADING,
    APPLY_THERAPIST_BULK_SIGNATURE_RESET,
} = DashboardConstants;

function* therapistBulkSignature(action: any): SagaReturnType<any> {
  try {
    yield put({ type: APPLY_THERAPIST_BULK_SIGNATURE_LOADING });
    const response = yield call(dashboardServices.applyTherapistBulkSign, action.payload);
    if (response?.status === 200) {
      yield put({ type: APPLY_THERAPIST_BULK_SIGNATURE_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: APPLY_THERAPIST_BULK_SIGNATURE_FAILURE, payload: error });
  }
}

function* therapistBulkSignatureSaga() {
  yield takeEvery(APPLY_THERAPIST_BULK_SIGNATURE_REQUEST, therapistBulkSignature);
}

export default therapistBulkSignatureSaga;
